import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetServiceDistributionTypes = (): Promise<any> =>
    request({
        url: ApiURL.Query.GetServiceDistributionTypes,
        method: RequestType.GET,
    });

const CargoCompanyDistributionAreasQuery = {
    GetServiceDistributionTypes,
};

export default CargoCompanyDistributionAreasQuery;

